import { createSlice, PayloadAction } from '@reduxjs/toolkit'

// Navigation slice state
interface NavigationState {
  selectedTab: number
  isVisible: boolean
}

const initialState: NavigationState = {
  selectedTab: 0,
  isVisible: true,
}

const navigationSlice = createSlice({
  name: 'navigation',
  initialState,
  reducers: {
    setSelectedTab: (state, action: PayloadAction<number>) => {
      state.selectedTab = action.payload
    },
    setVisibility: (state, action: PayloadAction<boolean>) => {
      state.isVisible = action.payload
    },
  },
})

export const { setSelectedTab, setVisibility } = navigationSlice.actions
export default navigationSlice.reducer
